export function isIPhoneDevice(device = typeof navigator === 'undefined' ? null : navigator) {
  if (!device || !/iPhone/i.test(device.userAgent || '')) return false;
  const platforms = [device.platform, device.userAgentData?.platform].filter(Boolean).join(' ');
  return !/Windows|Win32|Win64|Macintosh|MacIntel|Linux/i.test(platforms);
}

export function isAndroidDevice(device = typeof navigator === 'undefined' ? null : navigator) {
  if (!device) return false;
  const agent = device.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(agent)) return false;
  return /Android/i.test(agent) || /Android/i.test(device.userAgentData?.platform || '');
}

// 'apple' on iPhone, 'google' on Android, null elsewhere (no wallet card offered).
export function walletPlatform(device = typeof navigator === 'undefined' ? null : navigator) {
  if (isIPhoneDevice(device)) return 'apple';
  if (isAndroidDevice(device)) return 'google';
  return null;
}

export function walletName(platform) {
  return platform === 'google' ? 'Google Wallet' : 'Apple Wallet';
}
